<template>
  <!-- 报告卡片：用于经营预警下方的"报告"模块展示 -->
  <div class="report-card" @click="$emit('click', item)">
    <!-- 顶部：内/外部分类 + 报告类型 + 影响等级 + 异常状态 -->
    <div class="card-top">
      <span class="type-badge" :class="item.category === 'internal' ? 'type-internal' : 'type-external'">
        {{ item.category === 'internal' ? '内部' : '外部' }}
      </span>
      <span class="category-text">{{ reportTypeLabel }}</span>
      <span class="risk-badge" :style="{ color: impactColor }">{{ impactLabel }}</span>
      <!-- 异常状态角标：hasAnomaly 才展示 -->
      <template v-if="item.hasAnomaly">
        <span
          class="anomaly-badge"
          :class="anomalyStatusClass"
          @click.stop="handleAnomalyDetail"
        >
          {{ anomalyStatusLabel }}
        </span>
      </template>
    </div>

    <!-- 标题 -->
    <h5 class="card-title">{{ item.title || '未命名报告' }}</h5>

    <!-- 摘要 -->
    <p class="card-desc">{{ item.summary || '暂无摘要' }}</p>

    <!-- 底部：时间 + 数字人名称 + 异常详情按钮 -->
    <div class="card-bottom">
      <span class="card-time">
        <i class="fa fa-clock-o"></i> {{ item.createTime || item.updateTime || '—' }}
      </span>
      <template v-if="item.hasAnomaly">
        <button
          class="anomaly-detail-btn"
          @click.stop="handleAnomalyDetail"
        >
          <i class="el-icon-warning"></i> 异常详情
        </button>
      </template>
      <span class="card-owner" v-else>{{ item.agentName || '—' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CronReportCard',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    reportTypeLabel() {
      const map = {
        market: '市场行情',
        policy: '政策法规',
        competitor: '竞品动态'
      }
      return map[this.item.reportType] || this.item.reportType || '报告'
    },
    impactLabel() {
      const map = { 1: '重大影响', 2: '中度影响', 3: '常规监测' }
      return map[this.item.impactLevel] || '常规监测'
    },
    impactColor() {
      const map = { 1: '#e54b3d', 2: '#d98213', 3: '#94a3b8' }
      return map[this.item.impactLevel] || '#94a3b8'
    },
    anomalyStatusLabel() {
      const s = this.item.anomalyDispositionStatus
      if (!s) return '待处理'
      const map = {
        DONE: '已完成',
        FALSE_POSITIVE: '误报',
        DEFERRED: '暂缓'
      }
      return map[s] || '已处置'
    },
    anomalyStatusClass() {
      const s = this.item.anomalyDispositionStatus
      if (!s) return 'anomaly-pending'
      return 'anomaly-done'
    }
  },
  methods: {
    handleAnomalyDetail() {
      this.$emit('anomaly-detail', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
.report-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;

  &:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  }
}

.card-top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.type-badge {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 4px;
  font-weight: 600;

  &.type-internal {
    background: #eef2ff;
    color: #4a5ff3;
  }

  &.type-external {
    background: #f0fdf4;
    color: #16a34a;
  }
}

.category-text {
  font-size: 10px;
  color: #94a3b8;
}

.risk-badge {
  font-size: 10px;
  font-weight: 600;
  margin-left: auto;
}

.anomaly-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 10px;
  cursor: pointer;
  flex-shrink: 0;

  &.anomaly-pending {
    background: #fef2f2;
    color: #ef4444;
    border: 1px solid #fecaca;
  }

  &.anomaly-done {
    background: #f0fdf4;
    color: #16a34a;
    border: 1px solid #bbf7d0;
  }
}

.card-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-desc {
  font-size: 11px;
  color: #64748b;
  line-height: 1.5;
  margin: 0 0 8px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.card-time {
  font-size: 10px;
  color: #94a3b8;

  i {
    margin-right: 3px;
  }
}

.card-owner {
  font-size: 10px;
  color: #94a3b8;
}

.anomaly-detail-btn {
  font-size: 11px;
  color: #ef4444;
  background: transparent;
  border: 1px solid #fecaca;
  border-radius: 4px;
  padding: 2px 8px;
  cursor: pointer;
  transition: all 0.15s;
  line-height: 1.4;

  &:hover {
    background: #fef2f2;
  }

  i {
    margin-right: 2px;
  }
}
</style>
